import { CompanyCamProjectEditor } from "@/react/components/entityViews/files/components/editors/CompanyCamProjectEditor";
import { MoreMenu, MenuItem } from "@/modern/components/more-menu";
import { UploadFileMenuButton } from "./UploadFileMenuButton";
import { CameraIcon, ImageIcon, FileTextIcon, FilesIcon, Library } from "lucide-react";
import { useEntityFileContext } from "@/react/components/entityViews/files/context/EntityFileContext";
import { ButtonGroup } from "@/modern/components/ui/button-group";
import { Button } from "@/modern/components/ui/button-shadcn";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/modern/components/ui/tooltip";
import { EDITOR_KEYS } from "@/other/constants/EditorKeys";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";

export const FileMenu = () => {
  const { entityRecord } = useEntityFileContext();
  const { editorHandler } = useSwivuBryntumContext();

  const handleViewAllFiles = (initialTab?: "photos" | "documents") => {
    editorHandler.openEditor(EDITOR_KEYS.taskFilesEditor, entityRecord, { task: entityRecord, initialTab });
  };

  const handleMyMediaClick = () => {
    editorHandler.openEditor(EDITOR_KEYS.myMediaEditor, entityRecord, {
      entityRecord: entityRecord,
      entityType: entityRecord.entityType,
    });
  };

  const menuItems: MenuItem[] = [
    {
      itemVariant: "button" as const,
      menuText: "View all files",
      dropdownMenuItemProps: {
        onClick: () => handleViewAllFiles()
      },
      Component: () => {
        return (
          <button className="flex items-center gap-2 w-full cursor-default">
            <FilesIcon className="size-4 mr-1" />
            View all files
          </button>
        );
      }
    },
    {
      itemVariant: "modal" as const,
      variant: "title" as const,
      menuText: "Link Company Cam",
      Icon: CameraIcon,
      Component: CompanyCamProjectEditor,
      modalTitle: "Link company cam project",
      menuItemModalHeaderVariant: "title" as const
    }
  ];

  return (
    <ButtonGroup>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="entityHeader" onClick={() => handleViewAllFiles("photos")}>
            <ImageIcon />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>View all images</p>
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="entityHeader" onClick={() => handleViewAllFiles("documents")}>
            <FileTextIcon />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>View all documents</p>
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="entityHeader" onClick={handleMyMediaClick}>
            <Library />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>My Media</p>
        </TooltipContent>
      </Tooltip>
      <UploadFileMenuButton record={entityRecord} />
      <MoreMenu menuItems={menuItems} record={entityRecord} menuTitle="Files" triggerButtonVariant={"entityHeader"} />
    </ButtonGroup>
  );
};
